<div class="container-fluid" style="padding-left: 0; padding-right: 0;">
  <div class="row">
    <div class="col">
      <div *ngIf="loadingOperatives" class="text-center">
        <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
      </div>
      <div *ngIf="!loadingOperatives">
        <p-table #operativesTable [value]="operatives" [(selection)]="selectedOperatives"
                 [globalFilterFields]="['fullName', 'firstName', 'lastName', 'businessUnit', 'operativeType', 'jobTitle','currentWorkRisk.label','jobLevel.label','currentRiskMatrixLevel.label','startedOn','nextObservationFollowUp', 'totalCPDHours']" dataKey="id"
                 styleClass="p-datatable-striped p-datatable-responsive-eca"
                 [scrollable]="!isOnMobile && operatives.length > 5" scrollHeight="500px" [columns]="columns" [totalRecords]="operatives?.length">
          <ng-container>
            <ng-template pTemplate="caption" *ngIf="showTitleBar">
              <div class="row d-flex justify-content-between align-items-center">
                <div class=" col-xl-auto col-lg-12 col-md-12 col-sm-12">
                  <div class="row justify-content-xl-start  justify-content-lg-start justify-content-md-between justify-content-sm-between justify-content-between align-items-center">
                    <div class="col-auto">
                      <h5 class="eca-primary-text">
                        <span *ngIf="operatives"> {{ operatives.length }}</span>
                        Operatives
                        <span *ngIf="selectedOperatives.length > 0">({{ selectedOperatives.length }} Selected)</span>
                      </h5>
                    </div>
                    <div class="col-auto">
                      <app-eca-ghost-btn *ngIf="allowedOperations.canInsert && selectedOperatives.length === 0"
                                         btnText="Add New Operative"
                                         (btnClicked)="addOperative()"
                                         btnIcon="plus-circle" btnType="success">
                      </app-eca-ghost-btn>
                      <app-eca-ghost-btn *ngIf="allowedOperations.canUpdate && selectedOperatives.length > 0"
                                         [btnText]="'Add Training Records to ' + selectedOperatives.length + ' Operatives' "
                                         (btnClicked)="addTrainingToSelectedOperatives()"
                                         btnIcon="plus-circle" btnType="primary">
                      </app-eca-ghost-btn>
                      <app-eca-ghost-btn *ngIf="allowedOperations.canDelete && selectedOperatives.length > 0"
                                         [btnText]="'Remove ' + selectedOperatives.length + ' Operatives'"
                                         (btnClicked)="removeSelectedOperatives()"
                                         btnIcon="trash-alt" btnType="danger">
                      </app-eca-ghost-btn>
                    </div>
                  </div>
                </div>
                <div class=" col-xl-auto col-lg-12 col-md-12 col-sm-12 ">
                  <div class="row justify-content-xl-end  justify-content-lg-end justify-content-md-between justify-content-sm-between justify-content-between align-items-center">
                    <div class="col-xl-auto col-lg-auto col-md-12 col-sm-12 col-12 hide-on-small-screens">
                      <div class="row justify-content-xl-end d-flex justify-content-lg-between justify-content-md-between justify-content-sm-between justify-content-between align-items-center  ">
                        <div class="col d-flex justify-content-start align-items-center" *ngIf="isShowAllButtonVisible">
                          <label class="center-label" style="margin-bottom: 0;">Show Operatives</label>
                        </div>
                        <div class="col-xl-auto col-lg-auto col-md-auto col-sm-auto col-auto d-flex justify-content-between align-items-center">
                          <label style=" margin-bottom: 0; margin-right: 10px; " [ngStyle]="{'font-weight':  showAll ? '' : 'bold'}">All History</label>
                          <p-inputSwitch (onChange)="showAllToggled()" [(ngModel)]="showAll"></p-inputSwitch>
                          <label style="margin-bottom: 0; margin-left: 10px ;margin-right: 5px" [ngStyle]="{'font-weight':  showAll ? 'bold' : ''}">As of:</label>
                        </div>
                        <div class="col-xl-auto col-lg-auto col-md-auto col-sm-auto col-auto">
                          <app-eca-date-picker [isDisabled]="disableAsOfDate" [(dateValue)]="operativesAsOf" [controlId]="'ctrlOperativesAsOf'" (dateValueChange)="getOperativesAsOf()"></app-eca-date-picker>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-auto col-lg-auto col-md-12 col-sm-12 col-12">
                      <div class="row justify-content-xl-start  justify-content-lg-start justify-content-md-between justify-content-sm-between justify-content-between align-items-center">
                        <div class="col-xl-auto col-lg-auto col-md-auto col-sm-8 col">
                          <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" class="form-control" id="ctrlSearchInput" style="min-width: 150px"
                                   placeholder="Search All" [(ngModel)]="searchFilter"
                                   (input)="operativesTable.filterGlobal($event.target.value, 'contains')">
                          </span>
                        </div>
                        <div class="col-auto">
                          <app-eca-ghost-btn btnIcon="file-excel" btnText="Export" btnType="primary" (btnClicked)="exportToExcel()"></app-eca-ghost-btn>
                          <app-eca-ghost-btn btnIcon="file-excel" btnText="Training Matrix" btnType="primary" (btnClicked)="exportTrainingMatrix()"></app-eca-ghost-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-container>
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 6%" class="text-center" *ngIf="showMultiSelect && (allowedOperations?.canInsert || allowedOperations?.canUpdate || allowedOperations.canDelete)">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
              </th>
              <th style="width: 7%" pSortableColumn="firstName">
                First Name
                <p-sortIcon field="firstName"></p-sortIcon>
              </th>
              <th style="width: 7%" pSortableColumn="lastName">
                Last Name
                <p-sortIcon field="lastName"></p-sortIcon>
              </th>
              <th style="width: 10%" pSortableColumn="businessUnit">
                Business Unit
                <p-sortIcon field="businessUnit"></p-sortIcon>
              </th>
              <th style="width: 10%" pSortableColumn="operativeType">
                Operative Type
                <p-sortIcon field="operativeType"></p-sortIcon>
              </th>
              <th style="width: 8%" pSortableColumn="jobTitle">
                Job Role
                <p-sortIcon field="jobTitle"></p-sortIcon>
              </th>
              <th style="width: 8%" pSortableColumn="currentWorkRisk.label">
                Work Risk
                <p-sortIcon field="currentWorkRisk.label"></p-sortIcon>
                <p-columnFilter field="currentWorkRisk" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" *ngIf="showFilters">
                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-multiSelect [ngModel]="value" [options]="allRiskOptions" placeholder="Any" (onChange)="filter($event.value)"
                                   optionLabel="label" [filter]="false">
                      <ng-template let-option pTemplate="item">
                        <div class="p-multiselect-representative-option">
                          <span class="p-ml-1"> {{ option.label }}</span>
                        </div>
                      </ng-template>
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </th>
              <th style="width: 8%" pSortableColumn="jobLevel.label">
                Job Level
                <p-sortIcon field="jobLevel.label"></p-sortIcon>
                <div class="p-d-flex p-jc-between p-ai-center">
                  <p-columnFilter type="text" field="jobLevel" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" *ngIf="showFilters">
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                      <p-multiSelect [ngModel]="value" [options]="allJobLevelOptions" placeholder="Any" (onChange)="filter($event.value);"
                                     optionLabel="label" [filter]="false">
                        <ng-template let-option pTemplate="item">
                          <span class="p-ml-1"> {{ option.label}}</span>
                        </ng-template>
                      </p-multiSelect>
                    </ng-template>
                  </p-columnFilter>
                </div>
              </th>
              <th style="width: 8%" pSortableColumn="currentRiskMatrixLevel.label">
                Supervision
                <p-sortIcon field="currentRiskMatrixLevel.label"></p-sortIcon>
                <p-columnFilter field="currentRiskMatrixLevel" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" *ngIf="showFilters">

                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                    <p-multiSelect [ngModel]="value" [options]="allRiskMatrixOptions" placeholder="Any" (onChange)="filter($event.value)"
                                   optionLabel="label" [filter]="false">
                      <ng-template let-option pTemplate="item">
                        <div class="p-multiselect-representative-option">
                          <span class="p-ml-1"> {{ option.label }}</span>
                        </div>
                      </ng-template>
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </th>
              <th style="width: 8%" pSortableColumn="startedOn">
                Start Date
                <p-sortIcon field="startedOn"></p-sortIcon>
              </th>
              <th style="width: 8%" pSortableColumn="nextObservationFollowUp">
                Observation Due
                <p-sortIcon field="nextObservationFollowUp"></p-sortIcon>
              </th>
              <th style="width: 10%" pSortableColumn="totalCPDHours">
                Total CPD Hours
                <p-sortIcon field="totalCPDHours"></p-sortIcon>
              </th>
              <th style="width: 8%" pSortableColumn="endedOn" *ngIf="showEndDate()">
                End Date
                <p-sortIcon field="endedOn"></p-sortIcon>
              </th>

              <th style="width: 8%" *ngIf="showOperativeMenus"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-operative let-columns="columns">
            <tr [style.color]="operative.getRiskColour()">
              <td class="text-center" *ngIf="showMultiSelect && (allowedOperations?.canInsert || allowedOperations?.canUpdate || allowedOperations.canDelete)">
                <p-tableCheckbox [value]="operative"></p-tableCheckbox>
              </td>
              <td *ngFor="let col of columns">
                <span class="p-column-title">{{col.header}}: </span>
                <label>
                  <span *ngIf="col.type=== 'text'">
                    {{ operative[col.field] }}
                  </span>
                  <span *ngIf="col.type=== 'object'">
                    {{ operative[col.field]?.label }}
                  </span>
                  <span *ngIf="col.type === 'enum'">
                    {{ degreeOfSupervisionString[operative[col.field]] }}
                  </span>
                  <span *ngIf="col.type === 'date'">
                    {{ operative[col.field] | date:'dd/MM/yyyy' }}
                  </span>
                </label>
              </td>
              <td *ngIf="showEndDate()">
                {{ operative?.endedOn | date:'dd/MM/yyyy' }}
              </td>
              <td *ngIf="showOperativeMenus">
                <app-eca-row-menu (viewBtnClicked)="viewOperativeClicked(operative)"
                                  [rowMenuVisible]="showRowControllerButtons && allowedOperations.canDelete"
                                  [rowMenuItems]="rowMenuItems"
                                  [contextItem]="operative">
                </app-eca-row-menu>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
